import './Skeleton.css';

// 스켈레톤 기본 컴포넌트
const Skeleton = ({ 
  width, 
  height, 
  borderRadius = '4px',
  className = '',
  style = {}
}) => {
  return (
    <div 
      className={`skeleton ${className}`}
      style={{
        width,
        height,
        borderRadius,
        ...style
      }}
    />
  );
};

// 텍스트 스켈레톤 (한 줄)
export const SkeletonText = ({ 
  width = '100%', 
  height = '16px',
  className = ''
}) => (
  <Skeleton 
    width={width} 
    height={height} 
    className={`skeleton-text ${className}`}
  />
);

// 여러 줄 텍스트 스켈레톤
export const SkeletonTextLines = ({ 
  lines = 3, 
  lineHeight = '16px',
  lineSpacing = '8px',
  lastLineWidth = '60%',
  className = ''
}) => (
  <div className={`skeleton-text-lines ${className}`}>
    {Array.from({ length: lines }).map((_, index) => (
      <SkeletonText
        key={index}
        width={index === lines - 1 ? lastLineWidth : '100%'}
        height={lineHeight}
        style={{ marginBottom: index < lines - 1 ? lineSpacing : 0 }}
      />
    ))}
  </div>
);

// 원형 스켈레톤 (아바타, 프로필 이미지용)
export const SkeletonCircle = ({ 
  size = '40px', 
  className = ''
}) => (
  <Skeleton 
    width={size} 
    height={size} 
    borderRadius="50%"
    className={`skeleton-circle ${className}`}
  />
);

// 직사각형 스켈레톤 (이미지, 카드용)
export const SkeletonRectangle = ({ 
  width = '100%', 
  height = '200px',
  borderRadius = '8px',
  className = ''
}) => (
  <Skeleton 
    width={width} 
    height={height} 
    borderRadius={borderRadius}
    className={`skeleton-rectangle ${className}`}
  />
);

// 테이블 행 스켈레톤
export const SkeletonTableRow = ({ 
  columns = 5, 
  rowHeight = '56px',
  className = ''
}) => (
  <div className={`skeleton-table-row ${className}`}>
    {Array.from({ length: columns }).map((_, index) => (
      <div key={index} className="skeleton-table-cell">
        <SkeletonText 
          width={index === 0 ? '60px' : index === columns - 1 ? '80px' : '120px'}
          height="16px"
        />
      </div>
    ))}
  </div>
);

// 테이블 스켈레톤 (여러 행)
export const SkeletonTable = ({ 
  rows = 5, 
  columns = 5,
  className = ''
}) => (
  <div className={`skeleton-table ${className}`}>
    {/* 테이블 헤더 */}
    <div className="skeleton-table-header">
      {Array.from({ length: columns }).map((_, index) => (
        <div key={index} className="skeleton-table-header-cell">
          <SkeletonText 
            width={index === 0 ? '60px' : index === columns - 1 ? '80px' : '120px'}
            height="18px"
          />
        </div>
      ))}
    </div>
    
    {/* 테이블 바디 */}
    <div className="skeleton-table-body">
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <SkeletonTableRow 
          key={rowIndex} 
          columns={columns}
          className={rowIndex % 2 === 0 ? 'even-row' : 'odd-row'}
        />
      ))}
    </div>
  </div>
);

// 카드 스켈레톤
export const SkeletonCard = ({ 
  width = '300px',
  height = '200px',
  className = ''
}) => (
  <div className={`skeleton-card ${className}`}>
    <SkeletonRectangle 
      width="100%" 
      height="120px" 
      borderRadius="8px 8px 0 0"
    />
    <div className="skeleton-card-content">
      <SkeletonText width="80%" height="18px" />
      <SkeletonText width="60%" height="14px" />
      <SkeletonText width="40%" height="14px" />
    </div>
  </div>
);

// 리스트 아이템 스켈레톤
export const SkeletonListItem = ({ 
  showAvatar = true,
  showImage = false,
  lines = 2,
  className = ''
}) => (
  <div className={`skeleton-list-item ${className}`}>
    {showAvatar && (
      <SkeletonCircle size="48px" className="skeleton-avatar" />
    )}
    {showImage && (
      <SkeletonRectangle width="80px" height="60px" className="skeleton-image" />
    )}
    <div className="skeleton-list-content">
      <SkeletonTextLines lines={lines} />
    </div>
  </div>
);

// 그리드 스켈레톤
export const SkeletonGrid = ({ 
  items = 6, 
  columns = 3,
  itemHeight = '200px',
  className = ''
}) => (
  <div className={`skeleton-grid ${className}`}>
    {Array.from({ length: items }).map((_, index) => (
      <SkeletonCard 
        key={index}
        width="100%"
        height={itemHeight}
      />
    ))}
  </div>
);

export default Skeleton;
